import { type } from "arktype";

import { djs } from "@/lib/djs";

export const isoDate = type(/^\d{4}-\d{2}-\d{2}$/u).narrow((value, ctx) => {
	const parsed = djs(value, "YYYY-MM-DD", true);

	if (parsed.isValid() && parsed.format("YYYY-MM-DD") === value) {
		return true;
	}

	return ctx.reject({ expected: "a real calendar date", actual: value });
});
